import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postFileMethod, postMethod } from "../../requests";
import $ from "jquery";
import UserPersonalData from "./UserPersonalData";

const UserProfileData = (props) => {
    const { t } = useTranslation();
    const { setAlerts, checkServerData } = useContext(BasicContext);
    const { data } = props;
    const [blockForm, setBlockForm] = useState(false);
    const [avatar, setAvatar] = useState(null);
    const [formChanged, setFormChanged] = useState(false);
    const [user, setUser] = useState({
        name: data.user_name,
        surname: data.user_surname,
        phone: data.user_phone,
        ig: data.user_instagram ? data.user_instagram : "",
        address: data.user_address ? data.user_address : "",
        avatar_name: data.user_avatar_name ? data.user_avatar_name : null,
        terms: data.user_terms_agreement === "Y" ? true : false,
        rodo: data.user_rodo_agreement === "Y" ? true : false,
        ecc: data.user_ecc_agreement === "Y" ? true : false,
        newsletter: data.user_newsletter_agreement === "Y" ? true : false,
        user_long_booking: data.user_long_booking,
        user_roles: data.user_roles,
        user_status: data.user_stat_name,
    });

    const updateData = async (fileName) => {
        const res = await postMethod("/edit-personal-data", { user: user, newAvatar: fileName });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.editedUserData"), fading: 1500, id: "uploaded" }]);
            setFormChanged(false);
            setUser({ ...user, avatar_name: fileName });
        }
        setBlockForm(false);
    };
    const uploadAvatar = async () => {
        const data = new FormData();
        data.append("file", avatar);
        const res = await postFileMethod("/upload-avatar", data);
        if (checkServerData(res)) {
            updateData(res.data.fileName);
        } else setBlockForm(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (user.name.length === 0 || !user.name.replace(/\s+/, "")) {
            $("#addUserFormname").addClass("is-invalid");
            errors.push(t("error.emptyName"));
        }
        if (user.surname.length === 0 || !user.surname.replace(/\s+/, "")) {
            $("#addUserFormsurname").addClass("is-invalid");
            errors.push(t("error.emptySurname"));
        }

        if (user.phone.length === 0 || !user.phone.replace(/\s+/, "")) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.emptyPhone"));
        } else if (!/^(\+48\s?)?(\d{3}\s?\d{3}\s?\d{3})$/.test(user.phone)) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.invalidPhone"));
        }

        if (user.ig.length > 0 && !/^(?!.*\.\.)(?!.*\.$)(?!\d+$)[a-zA-Z0-9._]{1,30}$/.test(user.ig)) {
            $("#addUserFormig").addClass("is-invalid");
            errors.push(t("error.invalidIgNick"));
        }

        if (user.address.length > 0 && !user.address.replace(/\s+/, "")) {
            $("#addUserFormAddress").addClass("is-invalid");
            errors.push(t("error.invalidAddress"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.editingUserData") }]);
            setBlockForm(true);
            if (avatar) uploadAvatar(data);
            else updateData(null);
        }
    };

    return (
        <Fragment>
            <Col xs={12} className="px-4 px-lg-2 ">
                <p className="h5 mb-4">{t("users.personalData")}</p>
                <Form onSubmit={checkValidation} autoComplete="off">
                    <Row>
                        <UserPersonalData
                            formChanged={formChanged}
                            setFormChanged={setFormChanged}
                            user={user}
                            avatar={avatar}
                            setAvatar={setAvatar}
                            blockForm={blockForm}
                            setUser={setUser}
                        />
                        <Col xs={12}>
                            <Button type="submit" variant="primary" disabled={blockForm || !formChanged}>
                                {t("saveChanges")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Fragment>
    );
};

export default UserProfileData;
